module.exports = __webpack_public_path__ + "static/media/icone-cabeçalho.542b3133.svg";